// 菜单悬停黄色背景修复脚本
(function() {
    // 定义需要覆盖的黄色背景值
    const yellowBackgrounds = [
        'rgb(254, 244, 182)',
        '#fef4b6',
        'rgb(254,244,182)',
        '#fef4b6',
        'rgba(254, 244, 182, 1)',
        'rgba(254,244,182,1)'
    ];
    
    // 定义需要监听的菜单相关类
    const menuClasses = [
        'el-menu-item',
        'el-submenu__title',
        'custom-mqtt-item',
        'el-menu--popup',
        'el-menu--popup-bottom-start',
        'el-menu--popup-right-start',
        'el-menu--popup-top-start',
        'el-menu--popup-left-start',
        'el-menu',
        'el-submenu',
        'custom-menu-popper'
    ];
    
    // 创建一个全局样式表来强制覆盖黄色背景
    function createGlobalStyle() {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
            /* 强制覆盖所有可能的黄色背景 */
            .el-menu-item:hover,
            .el-menu-item:focus,
            .el-submenu__title:hover,
            .el-submenu__title:focus,
            .el-menu--horizontal>.el-menu-item:hover,
            .el-menu--horizontal>.el-menu-item:focus,
            .el-menu--horizontal>.el-submenu .el-submenu__title:hover,
            .el-menu--horizontal>.el-submenu .el-submenu__title:focus,
            .el-menu--popup .el-menu-item:hover,
            .el-menu--popup .el-menu-item:focus,
            .el-menu--popup .el-submenu__title:hover,
            .el-menu--popup .el-submenu__title:focus,
            .el-menu .el-menu-item:hover,
            .el-menu .el-menu-item:focus,
            .el-menu .el-submenu__title:hover,
            .el-menu .el-submenu__title:focus,
            /* 处理子菜单 */
            .el-menu .el-menu .el-menu-item:hover,
            .el-menu .el-menu .el-menu-item:focus,
            .el-menu .el-menu .el-submenu__title:hover,
            .el-menu .el-menu .el-submenu__title:focus,
            .el-menu--popup .el-menu .el-menu-item:hover,
            .el-menu--popup .el-menu .el-menu-item:focus,
            /* 强制匹配内联样式 */
            [style*="background-color: rgb(254, 244, 182)"],
            [style*="background-color:#fef4b6"],
            [style*="background-color: #fef4b6"],
            [style*="background-color:rgb(254,244,182)"],
            [style*="background: rgb(254, 244, 182)"],
            [style*="background:#fef4b6"],
            [style*="background: #fef4b6"] {
                background-color: #070707 !important;
                background: #070707 !important;
                color: #fff !important;
                border: none !important;
                box-shadow: none !important;
                outline: none !important;
                transition: none !important;
            }
            
            /* 特别处理弹出菜单 */
            .el-menu--popup,
            .el-menu--popup-bottom-start,
            .el-menu--popup-right-start,
            .el-menu--popup-top-start,
            .el-menu--popup-left-start,
            .custom-menu-popper,
            .el-menu--popup .el-menu,
            .el-menu--popup .el-menu-item,
            .el-menu--popup .el-submenu__title {
                background-color: #070707 !important;
                color: #fff !important;
                border: none !important;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5) !important;
            }
            
            /* 强制覆盖二级菜单下的子菜单项 */
            .el-menu .el-menu .el-menu-item,
            .el-menu .el-menu .el-submenu__title,
            .el-menu--popup .el-menu-item,
            .el-menu--popup .el-submenu__title,
            .el-menu--popup .el-menu .el-menu-item,
            .el-menu--popup .el-menu .el-submenu__title,
            /* 更深层次的嵌套菜单 */
            .el-menu .el-menu .el-menu .el-menu-item,
            .el-menu .el-menu .el-menu .el-submenu__title,
            .el-menu--popup .el-menu--popup .el-menu-item,
            .el-menu--popup .el-menu--popup .el-submenu__title,
            .el-menu--popup .el-menu .el-menu .el-menu-item,
            .el-menu--popup .el-menu .el-menu .el-submenu__title,
            /* 通配符选择器确保所有嵌套级别都被覆盖 */
            .el-menu .el-menu-item:hover,
            .el-menu .el-submenu__title:hover,
            .el-menu--popup .el-menu-item:hover,
            .el-menu--popup .el-submenu__title:hover {
                background-color: #070707 !important;
                color: #fff !important;
            }
        `;
        document.head.appendChild(style);
    }
    // 在DOM加载完成后执行
    document.addEventListener('DOMContentLoaded', function() {
        // 初始修复
        fixMenuHoverStyles();
        
        // 监听DOM变化，处理动态添加的菜单元素
        const observer = new MutationObserver(function(mutations) {
            fixMenuHoverStyles();
        });
        
        // 监听整个文档的变化
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });
        
        // 监听鼠标移动事件，实时修复所有菜单元素
        document.body.addEventListener('mousemove', function(e) {
            // 查找鼠标下的元素及其父元素，更全面地处理
            let target = e.target;
            while (target && target !== document.body) {
                // 检查是否是菜单相关元素
                if (target.classList) {
                    const isMenuElement = target.classList.contains('el-menu-item') || 
                                        target.classList.contains('el-submenu__title') || 
                                        target.classList.contains('custom-mqtt-item') ||
                                        target.classList.contains('el-menu--popup') ||
                                        target.classList.contains('el-submenu') ||
                                        (target.parentElement && target.parentElement.classList && 
                                         (target.parentElement.classList.contains('el-menu') || 
                                          target.parentElement.classList.contains('el-menu--popup')));
                    
                    if (isMenuElement && target.style) {
                        // 强制设置背景色
                        target.style.setProperty('background-color', '#070707', 'important');
                        target.style.setProperty('background', '#070707', 'important');
                        
                        // 检查背景色是否为黄色
                        const bgColor = window.getComputedStyle(target).backgroundColor;
                        if (yellowBackgrounds.some(color => bgColor.includes(color))) {
                            target.style.setProperty('background-color', '#070707', 'important');
                            target.style.setProperty('background', '#070707', 'important');
                        }
                    }
                }
                target = target.parentElement;
            }
            
            // 全局检查黄色元素
            fixYellowBackgrounds();
        });
        
        // 定期检查并修复菜单样式
        setInterval(fixMenuHoverStyles, 50);
        // 更频繁地检查黄色背景
        setInterval(fixYellowBackgrounds, 20);
        // 添加额外的事件监听
        ['click', 'mousedown', 'mouseup', 'focus', 'blur'].forEach(eventType => {
            document.body.addEventListener(eventType, function() {
                // 立即修复
                fixYellowBackgrounds();
                // 延迟修复，确保在事件处理后也能修复
                setTimeout(fixYellowBackgrounds, 10);
                setTimeout(fixYellowBackgrounds, 50);
            });
        });
    });
    
    // 专门修复黄色背景
    function fixYellowBackgrounds() {
        // 深度扫描所有菜单元素
        function scanAndFixMenuElements(element) {
            if (!element) return;
            
            // 检查当前元素
            if (element.style && (element.style.backgroundColor === 'rgb(254, 244, 182)' || 
                element.style.backgroundColor === '#fef4b6' || 
                yellowBackgrounds.some(bg => element.style.backgroundColor.includes(bg)))) {
                element.style.setProperty('background-color', '#070707', 'important');
                element.style.setProperty('transition', 'none', 'important');
            }
            
            // 检查子元素
            if (element.children && element.children.length > 0) {
                Array.from(element.children).forEach(scanAndFixMenuElements);
            }
        }
        
        // 扫描所有菜单容器
        document.querySelectorAll('.el-menu, .el-menu--popup').forEach(scanAndFixMenuElements);

        // 查找并修复所有带有黄色背景的元素
        const yellowElements = document.querySelectorAll('[style*="background-color: rgb(254, 244, 182)"], [style*="background-color: #fef4b6"], [style*="background-color:#fef4b6"], [style*="background-color:rgb(254,244,182)"]');
        yellowElements.forEach(el => {
            if (el && el.style) {
                el.style.setProperty('background-color', '#070707', 'important');
            }
        });
        
        // 特别处理一级菜单标题
        const submenuTitles = document.querySelectorAll('.el-submenu__title');
        submenuTitles.forEach(el => {
            if (el && el.style) {
                el.style.setProperty('background-color', '#070707', 'important');
                el.style.setProperty('transition', 'none', 'important');
            }
        });
    }
    
    // 修复菜单悬停样式
    function fixMenuHoverStyles() {
        // 递归处理所有菜单项，确保嵌套菜单也被处理
        function processMenuItemsRecursively(parentElement) {
            if (!parentElement) return;
            
            // 处理当前元素
            if (parentElement.classList && 
                (parentElement.classList.contains('el-menu-item') || 
                 parentElement.classList.contains('el-submenu__title') || 
                 parentElement.classList.contains('custom-mqtt-item'))) {
                
                if (parentElement.style) {
                    // 强制设置背景色
                    parentElement.style.setProperty('background-color', '#070707', 'important');
                    parentElement.style.setProperty('transition', 'none', 'important');
                    
                    // 添加事件监听
                    if (!parentElement._deepFixed) {
                        parentElement._deepFixed = true;
                        const forceDeepBackground = function(e) {
                            parentElement.style.setProperty('background-color', '#070707', 'important');
                            if (e) e.stopPropagation();
                        };
                        
                        parentElement.addEventListener('mouseenter', forceDeepBackground);
                        parentElement.addEventListener('mouseover', forceDeepBackground);
                        parentElement.addEventListener('mousemove', forceDeepBackground);
                        parentElement.addEventListener('focus', forceDeepBackground);
                    }
                }
            }
            
            // 处理子元素
            if (parentElement.children && parentElement.children.length > 0) {
                Array.from(parentElement.children).forEach(processMenuItemsRecursively);
            }
        }
        
        // 从顶层菜单开始递归处理
        document.querySelectorAll('.el-menu, .el-menu--popup').forEach(processMenuItemsRecursively);

        // 处理所有菜单项 - 包括嵌套菜单
        const menuItems = document.querySelectorAll('.el-menu-item, .el-submenu__title, .custom-mqtt-item, .el-menu .el-menu-item, .el-menu .el-submenu__title, .el-menu--popup .el-menu-item, .el-menu--popup .el-submenu__title');
        menuItems.forEach(el => {
            if (el && el.style) {
                // 检查是否有黄色背景
                const bgColor = el.style.backgroundColor;
                if (bgColor === 'rgb(254, 244, 182)' || bgColor === '#fef4b6') {
                    el.style.backgroundColor = '#070707';
                }
                
                // 添加内联样式覆盖
                el.style.setProperty('background-color', '#070707', 'important');
                el.style.setProperty('transition', 'none', 'important');
                
                // 添加鼠标事件监听 - 增强版
                if (!el._hoverFixed) {
                    el._hoverFixed = true;
                    // 创建一个强力的事件处理函数
                    const forceBlackBackground = function(e) {
                        // 强制设置当前元素背景
                        el.style.setProperty('background-color', '#070707', 'important');
                        el.style.setProperty('background', '#070707', 'important');
                        
                        // 检查并修复子元素
                        if (el.children && el.children.length > 0) {
                            Array.from(el.children).forEach(child => {
                                if (child && child.style) {
                                    child.style.setProperty('background-color', 'transparent', 'important');
                                    child.style.setProperty('background', 'transparent', 'important');
                                }
                            });
                        }
                        
                        // 阻止事件传播
                        if (e) e.stopPropagation();
                        if (e) e.preventDefault();
                    };
                    
                    // 添加多种事件监听
                    el.addEventListener('mouseenter', forceBlackBackground);
                    el.addEventListener('mouseover', forceBlackBackground);
                    el.addEventListener('mousemove', forceBlackBackground);
                    el.addEventListener('focus', forceBlackBackground);
                    el.addEventListener('click', function(e) {
                        forceBlackBackground(e);
                        // 延迟执行，确保在点击后也能保持正确的背景色
                        setTimeout(() => forceBlackBackground(), 0);
                        setTimeout(() => forceBlackBackground(), 50);
                        setTimeout(() => forceBlackBackground(), 100);
                    });
                }
            }
        });
        
        // 特别处理一级菜单标题
        const submenuTitles = document.querySelectorAll('.el-submenu__title');
        submenuTitles.forEach(el => {
            if (el && el.style) {
                el.style.setProperty('background-color', '#070707', 'important');
                el.style.setProperty('transition', 'none', 'important');
                el.style.setProperty('color', '#fff', 'important');
                
                // 添加更强的事件处理
                if (!el._submenuFixed) {
                    el._submenuFixed = true;
                    const forceBackground = function() {
                        el.style.setProperty('background-color', '#070707', 'important');
                        // 处理子元素
                        Array.from(el.children).forEach(child => {
                            if (child && child.style) {
                                child.style.setProperty('background-color', 'transparent', 'important');
                            }
                        });
                    };
                    
                    // 多事件监听
                    el.addEventListener('mouseenter', forceBackground);
                    el.addEventListener('mouseover', forceBackground);
                    el.addEventListener('mousemove', forceBackground);
                    el.addEventListener('focus', forceBackground);
                    
                    // 监听点击事件，在点击后也强制设置背景色
                    el.addEventListener('click', function() {
                        // 延迟执行，确保在展开完成后也能保持正确的背景色
                        setTimeout(forceBackground, 0);
                        setTimeout(forceBackground, 50);
                        setTimeout(forceBackground, 100);
                    });
                }
            }
        });
        
        // 特别处理弹出菜单 - 扩大选择器范围
        const popupMenus = document.querySelectorAll('.el-menu--popup, .el-menu--popup-bottom-start, .el-menu--popup-right-start, .el-menu--popup-top-start, .el-menu--popup-left-start, .custom-menu-popper, .el-menu--popup .el-menu, .el-menu--popup .el-menu .el-menu');
        popupMenus.forEach(menu => {
            if (menu && menu.style) {
                menu.style.setProperty('background-color', '#070707', 'important');
                menu.style.setProperty('border', 'none', 'important');
                menu.style.setProperty('box-shadow', '0 2px 12px 0 rgba(0, 0, 0, 0.5)', 'important');
                
                // 处理弹出菜单中的所有项
                const popupItems = menu.querySelectorAll('*');
                popupItems.forEach(item => {
                    if (item && item.style) {
                        // 如果是菜单项，强制设置背景色
                        if (item.classList && 
                            (item.classList.contains('el-menu-item') || 
                             item.classList.contains('el-submenu__title'))) {
                            item.style.setProperty('background-color', '#070707', 'important');
                            item.style.setProperty('transition', 'none', 'important');
                            item.style.setProperty('color', '#fff', 'important');
                            
                            // 添加事件监听
                            if (!item._popupFixed) {
                                item._popupFixed = true;
                                const forcePopupBackground = function(e) {
                                    item.style.setProperty('background-color', '#070707', 'important');
                                    if (e) e.stopPropagation();
                                };
                                
                                item.addEventListener('mouseenter', forcePopupBackground);
                                item.addEventListener('mouseover', forcePopupBackground);
                                item.addEventListener('mousemove', forcePopupBackground);
                                item.addEventListener('focus', forcePopupBackground);
                            }
                        }
                        // 如果有黄色背景，直接修复
                        const bgColor = item.style.backgroundColor;
                        if (bgColor === 'rgb(254, 244, 182)' || bgColor === '#fef4b6') {
                            item.style.setProperty('background-color', '#070707', 'important');
                        }
                    }
                });
            }
        });
        
        // 查找并修复所有带有黄色背景的元素
        const yellowElements = document.querySelectorAll('[style*="background-color: rgb(254, 244, 182)"], [style*="background-color: #fef4b6"], [style*="background-color:#fef4b6"], [style*="background-color:rgb(254,244,182)"]');
        yellowElements.forEach(el => {
            if (el && el.style) {
                el.style.setProperty('background-color', '#070707', 'important');
            }
        });
    }
})();
